import { Component, HostBinding, Input } from '@angular/core';
import { PromoCode, PromoCodeClaim } from '@queries/generated';

@Component({
  selector: 'vnm-promo-code-claim',
  templateUrl: './promo-code-claim.component.html',
  styleUrls: ['./promo-code-claim.component.scss']
})
export class PromoCodeClaimComponent {
  @HostBinding('class') get classAttr() {
    return this.record ? 'flex gap-xxs align-items-center' : 'hidden';
  }

  @Input() record: PromoCodeClaim;
  @Input() promoCode: PromoCode;
}
